import { Container, Graphics, Text } from 'pixi.js';
import { PlayerSide } from '../types/game.types';
import { lerp } from '../utils/animation';
import { FONT_UI, PALETTE } from './theme';

export class TurnIndicator extends Container {
  private eyebrow: Text;
  private label: Text;
  private background: Graphics;
  private pulse: number = 0;
  private currentSide: PlayerSide = PlayerSide.KIWI;

  constructor() {
    super();

    this.background = new Graphics();
    this.addChild(this.background);

    this.eyebrow = new Text('CURRENT TURN', {
      fontFamily: FONT_UI,
      fontSize: 12,
      fill: PALETTE.mist,
      fontWeight: '600',
      letterSpacing: 2.2,
    });
    this.eyebrow.x = 32;
    this.eyebrow.y = 12;
    this.addChild(this.eyebrow);

    this.label = new Text('', {
      fontFamily: FONT_UI,
      fontSize: 24,
      fill: PALETTE.ink,
      fontWeight: 'bold',
      letterSpacing: 0.8,
    });
    this.label.x = 32;
    this.label.y = 28;
    this.addChild(this.label);

    this.update(PlayerSide.KIWI);
  }

  update(currentSide: PlayerSide): void {
    this.currentSide = currentSide;
    this.pulse = 1;
    this.label.text =
      currentSide === PlayerSide.KIWI ? 'Kiwis to move' : 'Coconuts to move';
    this.drawIndicator();
  }

  animate(delta: number): void {
    this.pulse = lerp(this.pulse, 0, Math.min(delta * 7, 1));
    this.scale.set(1 + this.pulse * 0.03);
    this.alpha = 0.9 + this.pulse * 0.1;
    this.drawIndicator();
  }

  private drawIndicator(): void {
    const accentColor =
      this.currentSide === PlayerSide.KIWI ? PALETTE.kiwi : PALETTE.coconut;
    const w = Math.max(this.label.width + 36, 220);
    const h = 72;

    this.background.clear();
    this.background.beginFill(PALETTE.surface, 0.92);
    this.background.drawRoundedRect(0, 0, w, h, 22);
    this.background.endFill();

    this.background.beginFill(accentColor, 0.12 + this.pulse * 0.1);
    this.background.drawRoundedRect(0, 0, w, h, 22);
    this.background.endFill();

    this.background.lineStyle(1.2, 0xffffff, 0.14 + this.pulse * 0.08);
    this.background.drawRoundedRect(0, 0, w, h, 22);

    this.background.beginFill(accentColor, 0.95);
    this.background.drawRoundedRect(12, 20, 4, 32, 2);
    this.background.endFill();
  }
}
